// ============================================================
// หน้า ImportBillWater — นำเข้าไฟล์ข้อมูล : การแจ้งหนี้และจัดเก็บค่าน้ำ
// ------------------------------------------------------------
// นำเข้าบิลค่าน้ำจากไฟล์ Excel แบบ "มีเลขมาตรเดือนนี้ / เดือนก่อน"
// ระบบคำนวณให้เอง: หน่วยที่ใช้ = เลขมาตรเดือนนี้ - เลขมาตรเดือนก่อน
//
// ค่าที่ระบบเติมให้จากตั้งค่าโครงการ (ไม่ได้อยู่ในไฟล์):
//   ค่าน้ำ (คำนวณจากหน่วยที่ใช้), ค่ารักษาอุปกรณ์, ค่าส่วนกลาง, ค่าขยะ
// ค่าที่มาจากไฟล์: ค่าเคเบิล, ค่าประกันอัคคีภัย, รายได้อื่น ๆ, เพิ่มหนี้, ลดหนี้
//
// หลังนำเข้าสำเร็จจะสั่งคำนวณยอดค้าง/เบี้ยปรับใหม่ทั้งโครงการ (calculate_water)
// ============================================================

import React, { Component } from "react";
import { ReactExcel, readFile, generateObjects } from "@ramonak/react-excel";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar.js";
import excel_file from "../../assets/files/import_bill_water.xlsx";
import {
  tokens,
  success,
  alert,
  toFixed,
  GET,
  POST,
  format_date,
  getStorage,
  calculate_water,
  cal_water_bill,
  getWaterSetting,
  calcFireCost,
  loading,
  ExcelDropZone,
  ScrollTopButton,
  ActionIcon,
  ICON,
} from "../../shared/index.js";
import { WATER_BILL_SHEET_NAME, WATER_BILL_COLUMNS, buildBillRow, dropSampleRow } from "../../shared/domain/bill-import.js";
import { findInvalidColumn } from "../../shared/domain/customer-excel.js";

export default class Import extends Component {
  state = {
    import: null, // ไฟล์ที่อ่านเข้ามา
    currentSheet: null, // ชีตที่ ReactExcel แปลงแล้ว
    data_import: null, // บิลที่เตรียมนำเข้า
    data_customer: [], // รายชื่อลูกค้า (ใช้ room_size ตอนคิดค่าส่วนกลางตามขนาดห้อง)

    // ค่าจากตั้งค่าโครงการ
    common_expenses_type: 0,
    common_expenses: 0,
    equipment_maintenance_fee: 0,
    waste_cost: 0,
    cable_cost: 0,
    fire_cost: 0,
    add_debt: 0,
    reduce_debt: 0,
    // ตั้งค่าอัตราค่าน้ำ (ส่งให้ cal_water_bill ใช้)
    water_charge_start: 0,
    water_charge_end: 0,
    water_charge_price: 0,
    water_rate_list: [],
    water_calculate_type: 2,
  };

  componentDidMount() {
    loading(false);
    this.GetSetting();
  }

  // ---------- ตั้งค่าโครงการ ----------

  GetSetting = async () => {
    loading(true);
    const d = await getWaterSetting(getStorage("water_id"));
    if (d) {
      this.setState(
        {
          water_charge_start: Number(d.water_charge.water_charge_start),
          water_charge_end: Number(d.water_charge.water_charge_end),
          water_charge_price: toFixed(Number(d.water_charge.water_charge_price)),
          water_rate_list: d.water_rate_list,
          water_calculate_type: Number(d.water_calculate_type) || 2,
          cable_cost: d.cable_cost,
          common_expenses_type: d.common_expenses_type,
          common_expenses: d.common_expenses,
          equipment_maintenance_fee: d.equipment_maintenance_fee,
          waste_cost: d.waste_cost,
          add_debt: d.add_debt,
          reduce_debt: d.reduce_debt,
          // เบี้ยประกันเก็บเฉพาะเดือนที่ตั้งไว้
          fire_cost: calcFireCost(d, format_date(new Date(), "m")),
        },
        () => {
          // คิดค่าส่วนกลางตามขนาดห้อง จึงต้องโหลดรายชื่อลูกค้ามาดู room_size
          if (d.common_expenses_type) this.GetCustomerAll();
        }
      );
    }
    loading(false);
  };

  GetCustomerAll = async () => {
    const result = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (result?.status) this.setState({ data_customer: result.data.data });
  };

  // ---------- อ่านไฟล์ ----------

  handleFile = (file) => {
    readFile(file)
      .then((readedData) => {
        if (readedData.SheetNames[0] !== WATER_BILL_SHEET_NAME) {
          alert("info", "แจ้งเตือน", "ไฟล์ไม่ถูกต้อง");
          return;
        }
        // รอ 10ms ให้ ReactExcel อัปเดต currentSheet ก่อนอ่านข้อมูล
        this.setState({ import: readedData }, () => setTimeout(this.Import, 10));
      })
      .catch(console.error);
  };

  // ตรวจหัวคอลัมน์ + แปลงชีตเป็นรายการบิล
  Import = () => {
    const invalidColumn = findInvalidColumn(this.state.currentSheet[WATER_BILL_SHEET_NAME][0], WATER_BILL_COLUMNS);
    if (invalidColumn) {
      alert("warning", "แจ้งเตือน", `หัวคอลัมน์ "${invalidColumn}" ไม่ถูกต้อง`);
      return;
    }

    // ทำ Map ไว้ก่อน เพื่อหาลูกค้าตามบ้านเลขที่แบบ O(1) แทนการ find ซ้ำทุกแถว
    const customerByAddress = new Map(this.state.data_customer.map((c) => [c.address_number, c]));

    const data = generateObjects(this.state.currentSheet)
      .filter((item) => item["บ้านเลขที่"] !== "")
      .map((item) => {
        const current_gauge_number = Number(item["เลขมาตรเดือนนี้"]) || 0;
        const last_gauge_number = Number(item["เลขมาตรเดือนก่อน"]) || 0;
        const unit_used = Number(item["เลขมาตรเดือนนี้"]) - Number(item["เลขมาตรเดือนก่อน"]);
        const address = item["บ้านเลขที่"]?.toString()?.trim() || "";

        return buildBillRow({
          item,
          setting: this.state,
          customer: customerByAddress.get(address),
          water_bill: cal_water_bill(unit_used, this.state),
          gauge: { current_gauge_number, last_gauge_number, unit_used },
        });
      });

    this.setState({ data_import: dropSampleRow(data) });
  };

  // ---------- บันทึก ----------

  Create_Import = async () => {
    loading(true);
    const payload = {
      import_water: this.state.data_import.map((item) => ({
        ...item,
        date_of_note: item.date_of_note ? format_date(item.date_of_note, "yyyy-mm-dd", "en") : null,
      })),
    };
    const result = await POST(tokens, `v1/TH/import-file/import-water/${getStorage("project_id")}`, payload);
    if (result?.status) {
      // นำเข้าแล้วต้องคิดยอดค้าง/เบี้ยปรับ/ค่าต่อมิเตอร์ใหม่ทั้งโครงการ
      const cal = await calculate_water("");
      if (cal) success();
    }
    loading(false);
  };

  removeRow = (index) => {
    const data = [...this.state.data_import];
    data.splice(index, 1);
    this.setState({ data_import: data.length ? data : null });
  };

  render() {
    const { data_import } = this.state;

    // ช่องที่ต้องมีค่า — ว่างแล้วไฮไลต์แดง
    const tdRequired = (value) => <td className={value ? "text-left" : "text-left bg-danger-light"}>{value || "-"}</td>;
    const tdMoney = (value) => <td className="text-left">{value ? toFixed(value) : "0.00"}</td>;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="นำเข้าไฟล์ข้อมูล" page3="การแจ้งหนี้และจัดเก็บค่าน้ำ" />
        <div className="body">
          <div className="p-3">
            {/* หัวข้อ + ปุ่ม */}
            <div className="w-100 d-flex justify-content-between mb-3">
              <h4 className="mb-3">
                <b>นำเข้าไฟล์ข้อมูล : การแจ้งหนี้และจัดเก็บค่าน้ำ</b>
              </h4>
              <div className="d-flex">
                <button className="btn btn-outline-primary wpx-150 mx-1" onClick={() => (window.location.href = "/import")}>
                  <span className="icon-brand mr-2">{ICON.back}</span>ย้อนกลับ
                </button>
                {data_import && (
                  <button className="btn btn-danger wpx-150 mx-1" onClick={() => this.setState({ data_import: null })}>
                    ล้างค่า
                  </button>
                )}
                {data_import && (
                  <button className="btn btn-primary wpx-150 mx-1" onClick={this.Create_Import}>
                    นำเข้า
                  </button>
                )}
              </div>
            </div>

            {/* ยังไม่เลือกไฟล์ → กล่องลากวาง */}
            {!data_import && (
              <ExcelDropZone
                variant="page"
                templateFile={excel_file}
                templateName="import_bill_water.xlsx"
                templateLabel="template นำเข้าข้อมูลการแจ้งหนี้และจัดเก็บค่าน้ำ"
                onFile={this.handleFile}
              />
            )}

            {/* ตารางตรวจสอบก่อนนำเข้า */}
            {data_import && (
              <div className="card border-0 mb-3">
                <div className="card-header bg-dark-blue px-3 rounded-top">
                  <h4 className="mb-0 text-white">
                    <b>ข้อมูลนำเข้า</b>
                  </h4>
                </div>
                <div className="p-3">
                  <div className="table-responsive">
                    <table className="table text-nowrap">
                      <thead>
                        <tr className="bg-dark-blue text-white">
                          <th>บ้านเลขที่</th>
                          <th>ชื่อ-นามสกุล</th>
                          <th>วันที่จด</th>
                          <th>เลขมาตรเดือนนี้</th>
                          <th>เลขมาตรเดือนก่อน</th>
                          <th>หน่วยที่ใช้</th>
                          <th>ค่าน้ำประปา</th>
                          <th>ค่ารักษาอุปกรณ์</th>
                          <th>ค่าใช้จ่ายส่วนกลาง</th>
                          <th>ค่าขยะ</th>
                          <th>ค่าเคเบิล</th>
                          <th>ค่าประกันอัคคีภัย</th>
                          <th>รายได้อื่น ๆ</th>
                          <th>เพิ่มหนี้</th>
                          <th>หมายเหตุเพิ่มหนี้</th>
                          <th>ลดหนี้</th>
                          <th>หมายเหตุลดหนี้</th>
                          <th>รวมเป็นเงิน</th>
                          <th>ลบ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data_import.map((item, index) => (
                          <tr key={index}>
                            {tdRequired(item.address_number)}
                            <td className="text-left">{item.full_name || "-"}</td>
                            <td className={item.date_of_note ? "text-left" : "text-left bg-danger-light"}>{item.date_of_note ? format_date(item.date_of_note, "dd/mm/yyyy") : "-"}</td>
                            <td className="text-left">{item.current_gauge_number || "0"}</td>
                            <td className="text-left">{item.last_gauge_number || "0"}</td>
                            <td className="text-left">{item.unit_used || "0"}</td>
                            {tdMoney(item.water_bill)}
                            {tdMoney(item.equipment_maintenance_fee)}
                            {tdMoney(item.common_expenses)}
                            {tdMoney(item.waste_cost)}
                            {tdMoney(item.cable_cost)}
                            {tdMoney(item.fire_cost)}
                            {tdMoney(item.other_income)}
                            {tdMoney(item.add_debt)}
                            <td className="text-left">{item.remark_add_debt || "-"}</td>
                            {tdMoney(item.reduce_debt)}
                            <td className="text-left">{item.remark_reduce_debt || "-"}</td>
                            {tdMoney(item.total_amount)}
                            <td>
                              <ActionIcon color="danger" icon={ICON.delete} title="ลบแถวนี้" className="mx-auto mb-0" onClick={() => this.removeRow(index)} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {/* ตัวแปลงไฟล์ Excel ของ library — ซ่อนไว้ */}
            <div className="d-none">
              <ReactExcel initialData={this.state.import} onSheetUpdate={(s) => this.setState({ currentSheet: s })} activeSheetClassName="d-none" />
            </div>
          </div>
        </div>

        <ScrollTopButton />
      </div>
    );
  }
}
